window.calcScrollbarWidth = function () {
  let container = document.querySelector('.main-index') ?? document.body;
  let scrollbarWidth = window.innerWidth - container.clientWidth + 'px';
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth);
};
calcScrollbarWidth();

function waitForTransitionEnd(element, property = '*') {
  return new Promise((resolve) => {
    const onTransitionEnd = (e) => {
      if (e.propertyName !== property && property !== '*') return;
      element.removeEventListener('transitionend', onTransitionEnd);
      resolve();
    };
    element.addEventListener('transitionend', onTransitionEnd);
  });
}

function waitForAnimationEnd(element) {
  return new Promise((resolve) => {
    const onAnimationEnd = () => {
      element.removeEventListener('animationend', onAnimationEnd);
      resolve();
    };
    element.addEventListener('animationend', onAnimationEnd);
  });
}

function resetGlobalBanner() {
  fetch(`${window.routes.cart_url}/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        ['gb_dismissed']: '',
      },
    }),
    keepalive: true,
  });
}

function disableBodyScrolling(currentScroll) {
  const html = document.querySelector('html');
  const homepageScrollableElement = document.querySelector('.main-index');
  const body = homepageScrollableElement ?? document.body;

  if (homepageScrollableElement && window.matchMedia('(min-width: 1200px)').matches) {
  } else {
    html.style.scrollBehavior = 'auto';
    html.style.maxHeight = '100dvh';
    html.style.overflowY = 'scroll';
    body.style.overflowY = 'hidden';
    body.style.position = 'fixed';
    html.style.overscrollBehavior = 'none'; /* Prevent overscroll */
    html.style.touchAction = 'pan-x pan-y';
    body.style.width = '100%';
    body.style.top = '-' + currentScroll + 'px';
    body.style.setProperty('--scroll-offset', currentScroll + 'px');
    body.style.height = 'auto';
  }

  document.querySelectorAll('[data-pinnable-desktop]').forEach((x) => {
    if (window.matchMedia('(max-width: 959px)').matches) {
      return;
    }

    x.style.top = currentScroll + 'px';
  });
}

function enableBodyScrolling(currentScroll) {
  const html = document.querySelector('html');
  const homepageScrollableElement = document.querySelector('.main-index');
  const body = homepageScrollableElement ?? document.body;

  document.querySelectorAll('[data-pinnable-desktop]').forEach((x) => {
    if (window.matchMedia('(max-width: 959px)').matches) {
      return;
    }

    if (x.nodeName === 'GLOBAL-BANNER') {
      bannerOffset = 0;
    }

    x.style.top = null;
  });

  body.style.overflowY = 'auto';
  body.style.top = 'auto';
  body.style.position = 'static';
  html.style.maxHeight = null;
  body.style.width = 'auto';
  body.style.height = '';
  html.style.overflowY = '';
  document.documentElement.scrollTop = currentScroll;
  body.style.setProperty('--scroll-offset', '0px');
  body.style.overscrollBehavior = '';
  html.style.touchAction = '';
  html.style.scrollBehavior = 'smooth';
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// let initialWidth = window.innerWidth;
// let initialHeight = window.innerHeight;
//
// window.addEventListener('resize', function () {
//   let newWidth = window.innerWidth;
//   let newHeight = window.innerHeight;
//
//   if (newWidth === initialWidth && newHeight !== initialHeight) {
//     console.log('Resize triggered by mobile address bar');
//   } else if (newWidth !== initialWidth && newHeight !== initialHeight) {
//     console.log('Resize triggered by orientation change');
//   } else {
//     console.log('Resize triggered by another reason');
//   }
//
//   // Update the initial dimensions
//   initialWidth = newWidth;
//   initialHeight = newHeight;
// });

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
});

class DrawerElement extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById('drawer-wrapper');
    this.drawerOpen = false;
    this.triggers = document.querySelectorAll(`[data-panel-transition="OPEN_SHOP"]`);
    this.drawerMenu = this.querySelector('.drawer-inner');
    this.homepageScrollerParent = document.querySelector('.main-index');
    // this.bindEvents();
  }

  connectedCallback() {
    this.header = document.querySelector('header');
    this.expandedHeader = document.querySelector('expanded-header');
    this.html = document.querySelector('html');
    this.homepageScrollableElement = document.querySelector('.main-index');
    this.isHomepageScrollable =
      window.matchMedia('(min-width: 959px)').matches && this.homepageScrollableElement ? true : false;
    this.body = this.isHomepageScrollable ? this.homepageScrollableElement : document.body;
    this.scrollTopElement =
      this.homepageScrollableElement && this.isHomepageScrollable
        ? this.homepageScrollableElement
        : document.documentElement;
  }

  bindEvents() {
    // this.triggers.forEach((trigger) => {
    //   trigger.addEventListener('click', this.onDrawerTriggerClick.bind(this));
    // });
  }

  focusLevelOne(triggerElement) {}

  onDrawerTriggerClick(triggerElement) {
    console.log('onDrawerTriggerClick');
    this.resetSubNavs();
    const customEvent = new CustomEvent('drawer:toggle', {
      detail: {
        open: this.drawerOpen,
        triggerElement: triggerElement,
      },
    });

    this.dispatchEvent(customEvent);

    if (this.drawerOpen === false) {
      this.openDrawer();
      this.drawerOpen = true;
    }
  }

  openDrawer() {
    this.setAttribute('aria-hidden', false);
  }

  closeDrawer() {
    this.drawerOpen = false;
    this.setAttribute('aria-hidden', true);
    // document.body.classList.remove('pr-6', 'overflow-hidden');
    // this.closeAnimation();
  }
}

customElements.define('drawer-element', DrawerElement);

class FooterNavigation extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('h3').forEach((title) => title.addEventListener('click', this.onFooterTitleClick.bind(this)));
  }

  onFooterTitleClick(event) {
    if (window.innerWidth > 959) {
      return;
    }
    event.currentTarget.parentElement.classList.toggle('expanded');
  }
}

customElements.define('footer-navigation', FooterNavigation);

class FooterTerms extends HTMLElement {
  constructor() {
    super();
    this.querySelector('button').addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    const target = event.currentTarget;
    const isExpanded = target.getAttribute('aria-expanded') === 'true';
    target.parentElement.classList.toggle('expanded');
    target.setAttribute('aria-expanded', !isExpanded);
  }
}

customElements.define('footer-terms', FooterTerms);
